// Third-party libraries
import React, { Component } from "react";
import { Link } from "react-router-dom";

// Project dependancies
import {
  errorHandler,
  getCookie,
  getHeaders,
  loginUrl,
  newPlayerUrl,
  newPlayerPrefsUrl,
  setCookie,
} from "../apihelpers";
import { LoadingBar } from "../components/widgets";
import PropositionMenuJustCards from "../components/PropositionMenuJustCards";
import CancelIcon from "../svg/CancelIcon";
import { GAEvent, Meta } from "../utilities";

class NewPlayer extends Component {
  rando = Math.floor(Math.random() * 100) + 1;

  state = {
    data: {
      screen_name: "",
      username: "",
      password: "",
      report: true,
      subscribe_to_wap_newsletter: true,
      is_subscribed_to_digest: true,
      is_subscribed_to_reminders: false,
      email: "",
      location: "",
      twitter: "",
      url: "",
      invited_by: getCookie("invite") || "none",
    },
    openPropCount: 0,
    playerCreated: false,
    prefsLogged: false,
    loading: false,
    error: false,
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handlePrefSubmit = this.handlePrefSubmit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.login = this.login.bind(this);
  }

  handlePrefSubmit(event) {
    const headers = getHeaders();
    window.scrollTo(0, 0);
    this.setState({ loading: true }, () => {
      fetch(newPlayerPrefsUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(this.state.data),
      })
        .then((response) => response.json())
        .then((json) => {
          this.setState({
            loading: false,
            prefsLogged: true,
            openPropCount: json.openPropCount,
          });
        })
        // eslint-disable-next-line no-console
        .catch((error) => console.log(error));
    });

    event.preventDefault();
  }

  handleSubmit(event) {
    const headers = getHeaders();
    window.scrollTo(0, 0);
    this.setState(
      {
        loading: true,
        emailError: "",
        passwordError: "",
        usernameError: "",
        screen_nameError: "",
        error: false,
      },
      () => {
        fetch(newPlayerUrl, {
          method: "POST",
          headers,
          body: JSON.stringify(this.state.data),
        })
          .then((response) => {
            if (response.status === 400) {
              this.setState({ error: true, loading: false });
              return response.json();
            } else {
              window.gtag("event", "conversion", {
                send_to: "AW-756722270/tenQCOGTgZcBEN7U6ugC",
              }); // Google ads conversion
              this.setState({ playerCreated: true });
              this.login(this.state.data.username, this.state.data.password);
            }
          })
          .then((errorResponse) => {
            if (errorResponse) {
              if (errorResponse.screen_name) {
                this.setState({
                  screen_nameError: errorResponse.screen_name
                    .map((msg) =>
                      msg.replace(
                        "player with this screen name",
                        "A player with with name"
                      )
                    )
                    .join(" "),
                });
              }
              if (errorResponse.username) {
                this.setState({
                  usernameError: errorResponse.username
                    .map((msg) => msg.replace("A user", "A player"))
                    .join(" "),
                });
              }
              if (errorResponse.email) {
                this.setState({
                  emailError: errorResponse.email
                    .map((msg) =>
                      msg.replace(
                        "user with this email address",
                        "A player with this address"
                      )
                    )
                    .join(" "),
                });
              }
              if (errorResponse.password) {
                this.setState({
                  passwordError: errorResponse.password.join(" "),
                });
              }
            }
          })
          .catch((error) => console.log(error));
      }
    );
    event.preventDefault();
  }

  handleChange(event) {
    const target = event.target;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (name === "username") {
      value = value.toLowerCase().replace(" ", "-");
    }
    if (
      name === "url" &&
      value.length > 4 &&
      value.substring(0, 4) !== "http"
    ) {
      value = "http://" + value;
    }
    if (name === "twitter" && value.length > 0) {
      value = "@" + value.toLowerCase().replace("@", "").replace(" ", "_");
    }
    let data = Object.assign({}, this.state.data);

    data[name] = value;

    this.setState({
      data: data,
    });
  }

  login(username, password) {
    const headers = getHeaders();
    fetch(loginUrl, {
      method: "POST",
      headers,
      body: JSON.stringify({ username, password }),
    })
      .then(errorHandler)
      .then((data) => {
        if (data.auth_token) {
          window.gtag("event", "login", { method: "djoser" });
          setCookie("token", data.auth_token, 30);
          this.setState({ loading: false });
          this.props.afterLogin();
        }
      })
      .catch(() => this.setState({ badLogin: true, showBadLoginAlert: true }));
  }

  render() {
    // The user has created an account and logged in for the first time
    if (
      this.state.playerCreated &&
      !this.state.loading &&
      !this.state.prefsLogged
    ) {
      return (
        <>
          <Meta
            title="Welcome to Rouleur Derby"
            description="First log-in after creating a new account."
          />
          <GAEvent action="create" category="account" />
          <h1>Welcome!</h1>

          <p>
            Now take a moment add some optional information to your profile and
            select your email preferences.
          </p>
          <form onSubmit={this.handlePrefSubmit}>
            <div className="form__row">
              <div className="form__col--50">
                <label htmlFor="twitter">Twitter handle</label>
                <input
                  id="twitter"
                  name="twitter"
                  onChange={this.handleChange}
                  value={this.state.data.twitter}
                  type="text"
                />
              </div>

              <div className="form__col--50">
                <label htmlFor="url">Home page</label>
                <input
                  id="url"
                  name="url"
                  onChange={this.handleChange}
                  value={this.state.data.url}
                  type="text"
                />
              </div>
            </div>
            <label htmlFor="location">Location</label>
            <input
              id="location"
              name="location"
              onChange={this.handleChange}
              value={this.state.data.location}
              type="text"
            />
            <div className="new-player__newsletters">
              <input
                id="report"
                name="report"
                onChange={this.handleChange}
                checked={this.state.data.report}
                type="checkbox"
              />
              <label htmlFor="report" className="label--regular">
                <strong>Yes,</strong> subscribe me to the Rouleur Derby Report,
                a weekly-ish email newsletter with updates about Rouleur Derby.
              </label>

              <input
                id="digest"
                name="is_subscribed_to_digest"
                onChange={this.handleChange}
                checked={this.state.data.is_subscribed_to_digest}
                type="checkbox"
              />
              <label htmlFor="digest" className="label--regular">
                <strong>Yes,</strong> subscribe me to the Rouleur Derby Digest,
                a short summary of your betting results, no more than once a
                day.
              </label>

              <input
                id="reminder"
                name="is_subscribed_to_reminders"
                onChange={this.handleChange}
                checked={this.state.data.is_subscribed_to_reminders}
                type="checkbox"
              />
              <label htmlFor="reminder" className="label--regular">
                <strong>Yes,</strong> email me a reminder four hours before any
                betting closes.
              </label>

              <input
                id="subscribe_to_wap_newsletter"
                name="subscribe_to_wap_newsletter"
                onChange={this.handleChange}
                checked={this.state.data.subscribe_to_wap_newsletter}
                type="checkbox"
              />
              <label
                htmlFor="subscribe_to_wap_newsletter"
                className="label--regular"
              >
                <strong>Yes,</strong> subscribe me to the monthly{" "}
                <a
                  href="https://www.wideanglepodium.com"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Wide Angle Podium
                </a>{" "}
                newsletter for updates on the world’s finest cycling podcasts.
              </label>
            </div>

            <input
              className="new-player__submit"
              type="submit"
              value={"Start playing"}
            />
          </form>
        </>
      );
    } else if (this.state.prefsLogged && !this.state.loading) {
      return (
        <>
          <GAEvent action="edit preferences after join" category="account" />
          <h1>You’re now ready to start betting!</h1>

          <p>
            Until you’ve made five unique bets, you will be limited to betting
            25 points at a time.
          </p>
          <p>
            You may also want to familiarize yourself with{" "}
            <Link to="/rd/about">how to play</Link> and{" "}
            <Link to="/rd/rules">the rules</Link>.
          </p>
          {this.state.openPropCount > 0 && (
            <>
              <p>
                Here{" "}
                {this.state.openPropCount > 1 ? (
                  <>
                    are some upcoming propositions you can start with, or you
                    can see the{" "}
                    <Link to="/">full list of open propositions</Link>
                  </>
                ) : (
                  "is an upcoming proposition you can start with"
                )}
                :
              </p>
              <PropositionMenuJustCards count={3} noHeader />
            </>
          )}
          <p>
            P.S. Check your email for a welcome message from Rouleur Derby.
            You’re also going to receive an invitation to join{" "}
            <a href="http://rouleurderby.slack.com">Rouleur Derby on Slack</a>,
            where you and other players can chat about the game and bike racing
            in general.
          </p>
        </>
      );
    }

    // The user is already logged in.
    else if (this.props.loggedIn && !this.state.loading) {
      return (
        <>
          <Meta
            title="Create New Account"
            description="Come join Rouleur Derby, the free and exciting game that lets you bet on professional cycling."
          />
          <p>
            You already have an account. Let’s go{" "}
            <Link to="/">make some bets!</Link>
          </p>
          <PropositionMenuJustCards count={3} />
        </>
      );
    }

    // The user has just submitted their info and is waiting for a response.
    else if (this.state.loading) {
      return (
        <>
          <LoadingBar />
        </>
      );
    }

    // Otherwise, it's a new player. Let's show them the form.
    else if (!this.state.playerCreated) {
      return (
        <>
          {this.state.error ? (
            <>
              <h1>Bugger!</h1>
              <Meta
                title="Create New Account (Error)"
                description="Come join Rouleur Derby, the free and exciting game that lets you bet on professional cycling."
              />

              <p className="paragraph--error">
                <CancelIcon /> There were errors with your information. Please
                correct them as indicated.
              </p>
            </>
          ) : (
            <>
              <Meta
                title="Create New Account"
                description="Come join Rouleur Derby, the free and exciting game that lets you bet on professional cycling."
              />

              <h1>Create a New Account</h1>
              <p>Rouleur Derby is free to play.</p>
            </>
          )}

          <form onSubmit={this.handleSubmit}>
            <div className="form__row">
              <div className="form__col--50">
                <label htmlFor="username">Username</label>

                <input
                  id="username"
                  name="username"
                  onChange={this.handleChange}
                  value={this.state.data.username}
                  type="text"
                  className={
                    this.state.usernameError ? "text-input--error" : ""
                  }
                  required
                />
                {this.state.usernameError ? (
                  <div className="input-error error">
                    {this.state.usernameError}
                  </div>
                ) : (
                  <div className="input-helper">
                    You will use this to log in, and it will be used as the
                    address for your profile page. For example:
                    rouleurderby.com/tomboonen.
                  </div>
                )}
              </div>
              <div className="form__col--50">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  name="password"
                  onChange={this.handleChange}
                  value={this.state.data.password}
                  type="password"
                  className={this.state.password ? "text-input--error" : ""}
                  required
                />
                {this.state.passwordError ? (
                  <div className="input-error error">
                    {this.state.passwordError}
                  </div>
                ) : (
                  <div className="input-helper">
                    Must be at least eight characters.
                  </div>
                )}
              </div>
            </div>

            <div className="form__row">
              <div className="form__col--50">
                <label htmlFor="screen_name">Name</label>

                <input
                  id="screen_name"
                  name="screen_name"
                  onChange={this.handleChange}
                  value={this.state.data.screen_name}
                  type="text"
                  className={
                    this.state.screen_nameError ? "text-input--error" : ""
                  }
                />

                {this.state.screen_nameError ? (
                  <div className="input-error error">
                    {this.state.screen_nameError}
                  </div>
                ) : (
                  <div className="input-helper">
                    This is the name that will appear in the leaderboard and on
                    your public profile page.
                  </div>
                )}
              </div>
              <div className="form__col--50">
                <label htmlFor="newemail">Email</label>

                <input
                  id="email"
                  name="email"
                  onChange={this.handleChange}
                  value={this.state.data.email}
                  type="email"
                  required
                  className={this.state.emailError ? "text-input--error" : ""}
                />

                {this.state.emailError ? (
                  <div className="input-error error">
                    {this.state.emailError}
                  </div>
                ) : (
                  <div className="input-helper">
                    Your email will not be made public. It will be used only for
                    communication from Rouleur Derby.
                  </div>
                )}
              </div>
            </div>

            <input
              className="new-player__submit"
              type="submit"
              value={"Create new account"}
            />
          </form>
        </>
      );
    }
  }
}

export default NewPlayer;
